/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "ek-branches-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ek-companies-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ek-events-master",
            "region": "eu-west-1"
        },
        {
            "tableName": "ek-teilnehmer-master",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "cms-einkaufskreis-storage-master",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:f50654e3-a3b4-449d-a15c-677c354143df",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_VqFvHSSu8",
    "aws_user_pools_web_client_id": "4djsv5r5tbekj22lkakumuapev",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "cmseinkaufskreisApi",
            "endpoint": "https://fws7ozlp7i.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        },
        {
            "name": "backend",
            "endpoint": "https://mihmtxkia9.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ],
    "aws_content_delivery_bucket": "cmseinkaufskreisat-20190119122733-hostingbucket-master",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://dnduis1alq8zi.cloudfront.net",
    "aws_cognito_login_mechanisms": [
        "PREFERRED_USERNAME"
    ]
};


export default awsmobile;
